import { GET_MENU, GET_MENU_SUCCESS } from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  menu: null,
};

const menu = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_MENU_SUCCESS:
      state = {
        ...state,
        menu: action.payload,
        loading: false,
      };
      break;
  }
  return state;
};

export default menu;
